import { render } from "./ModalBase.vue?vue&type=template&id=838d1498&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=838d1498&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-838d1498"

export default script